
  import search from "@/mixins/search";
  import property from "@/mixins/property";
  import propertyFormat from "@/mixins/propertyFormat";

  export default {
    name: "PropertiesListItem",
    head() {
      return {
        link: [
          {
            rel: "stylesheet",
            href:
              "https://cdnjs.cloudflare.com/ajax/libs/leaflet.markercluster/1.5.0/MarkerCluster.Default.css"
          },
          {
            rel: "stylesheet",
            href:
              "https://cdnjs.cloudflare.com/ajax/libs/leaflet.markercluster/1.5.0/MarkerCluster.css"
          }
        ]
      };
    },
    mixins: [
      search,
      property,
      propertyFormat,
    ],
    props: {
      propertyHoverId: {
        default: null
      }
    },
    methods: {
      propertyDescription(description, num = 180) {
        let text = '';

        if (!!description && !!description[this.$i18n.locale]) {
          text = description[this.$i18n.locale];
        }

        if (text.length > num) {
          return `${text}...`;
        }

        return text;
      }
    },
  };
